<template>
	<div class="tool">
		<div>
			<div class="mb-tabs">
				<el-tabs v-model="activeTitle" @tab-click="checkTab">
					<div></div>
					<el-tab-pane v-for="(tab, idx) in tabsList" :key="idx" :name="tab.id + ''">
						<template slot="label">
							<el-tooltip
								:content="tab.describe"
								placement="bottom"
								effect="light"
								popper-class="tooltip_class"
								:visible-arrow="false"
							>
								<div>
									<div class="label-img">
										<img :src="tab.img" />
									</div>
									<div class="label-title">{{ tab.name }}</div>

									<div class="label-font">{{ tab.describe }}</div>
								</div>
							</el-tooltip>
						</template>
					</el-tab-pane>
				</el-tabs>
			</div>
			<div>
				<!-- 
					轮播展示
					翻译图片选项
					根据固定id判断页面展示效果
				 -->
				<div v-if="checkTabObj.id == con">
					<mbCarousel
						:cardList="checkTabObj.list"
						:totalPrice="totalPrice"
						@mb-check-card="checkCard"
						@mb-buy-btn="payBtn"
					>
						<div slot="buyOption">
							<div class="inline-block-div">
								<div class="text-height">购买{{ childCheckCardData.name }}加购包数：</div>
								<div class="text-height">购买数量：</div>
							</div>
							<div class="inline-block-div">
								<div class="row-height">
									<span>
										<el-input-number
											v-model="packgeCount"
											@change="changeCount"
											:min="1"
											:max="100"
											size="small"
										></el-input-number>
										个
									</span>
									<span class="ml20">共计：{{ packgeCount }} 个</span>
								</div>
								<div class="row-height">
									<el-radio-group v-model="radioLabel" size="medium" @change="checkOrderCnt">
										<el-radio
											:label="btn.orderCnt"
											border
											v-for="(btn, idx) in childCheckCardData.attribute"
											:key="idx"
										>
											{{ btn.orderCnt }}{{ btn.priceUnit }}
										</el-radio>
									</el-radio-group>
								</div>
							</div>
						</div>
					</mbCarousel>
				</div>
				<!-- 卡片展示 -->
				<div v-else style="display: flex; justify-content: space-around; height: 230px">
					<div class="shop-card" v-for="(card, idx) in checkTabObj.list" :key="idx" :class="classAry[idx]">
						<div>
							<div class="fs24 mgb10 textc">
								<b>{{ card.name }}</b>
							</div>
							<div class="cen">
								<div class="card-title">加购包包含<span></span></div>
								<div class="card-content">：{{ card.haveContent }}</div>
							</div>
							<div class="mb10 cen">
								<div class="card-title">售价<span></span></div>
								<div class="card-content">
									：￥<span class="fs24">{{ card.price }}</span
									>/{{ card.priceUnit }}
								</div>
							</div>
							<div class="cen" v-if="Number(card.renewPrice)">
								<div class="card-title">续费<span></span></div>
								<div class="card-content">
									：￥<span class="fs24">{{ card.renewPrice }}</span
									>/{{ card.priceUnit }}
								</div>
							</div>
							<div class="textc" style="margin-top: 5px">
								<el-button
									size="small"
									style="background: #e69752; border: none; color: white"
									@click="buyBtn(card.id)"
									>点击购买</el-button
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { editions } from '@/utils/api'
import mbCarousel from '@/components/mb-carousel'
import Constant from '@/utils/constant'
import { mabangPay } from '@/utils/constant'

export default {
	components: {
		mbCarousel,
	},
	data() {
		return {
			tabsList: [],
			classAry: ['bg1', 'bg2', 'bg1', 'bg2'],
			// cardList: [],
			activeTitle: null,
			checkTabObj: {},
			totalPrice: 0,
			packgeCount: 1,
			packgePrice: 0,
			childCheckCardData: {},
			radioLabel: 0,
			con: Constant.TOOL_IMAGE_ID,
		}
	},
	mounted() {
		this.getTabs()
	},
	methods: {
		buyBtn(goodsId) {
			let params = {
				goodsId: goodsId,
				buyNum: 1,
				moduleId: JSON.parse(sessionStorage.getItem('projectInfo')).id,
			}
			mabangPay(params)
		},
		getTabs() {
			let params = {
				moduleId: JSON.parse(sessionStorage.getItem('projectInfo')).id,
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
			}
			editions(params).then((res) => {
				this.tabsList = [...res]
				if (this.$route.query.editionId) {
					this.activeTitle = this.$route.query.editionId + ''
					this.tabsList.forEach((item) => {
						if (item.id == this.$route.query.editionId) {
							this.checkTabObj = { ...item }
						}
					})
				} else {
					this.activeTitle = this.tabsList[0].id + ''
					this.checkTabObj = { ...res[0] }
				}

				// this.cardList = [...res[0].list]
			})
		},
		checkTab() {
			let obj = this.tabsList.filter((item) => item.id == this.activeTitle)
			this.checkTabObj = { ...obj[0] }
			// this.cardList = [...this.checkTabObj.list]
		},
		checkCard(card) {
			this.childCheckCardData = card
			this.radioLabel = this.childCheckCardData.attribute[0].orderCnt
			this.packgePrice = this.childCheckCardData.price
			this.calcTotalPrice()
		},
		changeCount() {
			this.calcTotalPrice()
		},
		calcTotalPrice() {
			this.totalPrice = this.packgeCount * this.packgePrice
		},
		payBtn() {
			let params = {
				goodsId: this.childCheckCardData.id,
				buyNum: this.packgeCount,
				purchaseTime: this.radioLabel,
				moduleId: JSON.parse(sessionStorage.getItem('projectInfo')).id,
			}
			mabangPay(params)
		},
		checkOrderCnt(label) {
			let targetAry = this.childCheckCardData.attribute.filter((item) => item.orderCnt == label)
			this.packgePrice = targetAry[0].price
			this.calcTotalPrice()
		},
	},
}
</script>

<style scoped>
.el-carousel__item h3 {
	color: black;
	font-size: 18px;
	opacity: 0.75;
	line-height: 300px;
	margin: 0;
}

.shop-card {
	width: 35%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.bg1 {
	background: url('~@/assets/images/bg1.png') no-repeat 0 0;
	background-size: 100% 100%;
	color: black;
}

.bg2 {
	background: url('~@/assets/images/bg2.png') no-repeat 0 0;
	background-size: 100% 100%;
	color: #e9bd9c;
}

.row-height {
	height: 50px;
	line-height: 50px;
}
</style>
